<template>
    <app-tabela
        :itens="consultoriasLista"
        :campos="campos"
        :itensPorPagina="itensPorPagina"
        :mostrarFiltro="false"
        :bordered="false"
        :small="false"
    >
        <template slot="nomeConsultoria" slot-scope="data">
            {{ data.nomeConsultoria }}
        </template>
        <template slot="situacao" slot-scope="data">
            <app-status :status="data.situacao.toUpperCase()"></app-status>
        </template>
        <template slot="botoes">
            <slot name="botoes"></slot>
        </template>
        <template slot="acoes" slot-scope="data">
            <btn-atualizar-consultoria
                :dataServicos="dataServicos"
                :acao="acao"
                :consultoria="data"
                @atualizarLista="atualizarConsultorias()"
                @atualizarErros="$emit('atualizarErros', $event)"
            ></btn-atualizar-consultoria>
            <!-- <btn-cancelar-evento
                v-if="permiteCancelarEventos"
                :dataServicos="dataServicos"
                :evento="data"
                :acao="acao"
                @atualizarLista="atualizarConsultorias()">
            </btn-cancelar-evento> -->

            <metas-consultoria
                v-if="temAcessoMetas"
                :dataServicos="dataServicos"
                :permiteInserirMetas="permiteInserirMetas"
                :permiteCancelarMetas="permiteCancelarMetas"
                :evento="data"
                :acao="acao"
                @atualizarLista="atualizarConsultorias()"
            >
            </metas-consultoria>
            <slot name="acoes" v-bind="data"></slot>
        </template>
    </app-tabela>
</template>

<script>
import BtnAtualizarConsultoria from './BtnAtualizarConsultoria'
import BtnCancelarEvento from './BtnCancelarEvento'
import DocumentosEvento from './DocumentosEvento'
import MetasConsultoria from './metas/MetasConsultoria'

export default {
    components: {
        BtnAtualizarConsultoria,
        BtnCancelarEvento,
        DocumentosEvento,

        MetasConsultoria
    },

    props: {
        consultorias: {
            type: Array,
            default: () => []
        },

        operacao: {
            type: String,
            default: () => 'D'
        },

        acao: {
            type: Object,
            default: () => ({})
        },

        dataServicos: {
            type: Object
        },

        permiteCancelarEventos: {
            type: Boolean,
            default: () => false
        },

        temAcessoDocumentosEvento: {
            type: Boolean,
            default: () => false
        },

        temAcessoMetas: {
            type: Boolean,
            default: () => false
        },

        permiteInserirMetas: {
            type: Boolean,
            default: () => false
        },

        permiteCancelarMetas: {
            type: Boolean,
            default: () => false
        },

        permiteInserirAtualizarEventos: {
            type: Boolean,
            default: () => false
        },

        permiteInserirCancelarDocumentosEvento: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'nomeConsultoria',
                    label: 'Nome da Consultoria',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'totalPrevisto',
                    label: 'Total Previsto(Horas)',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'totalRealizado',
                    label: 'Total Realizado(Horas)',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5,
            consultoriasLista: []
        }
    },

    methods: {
        atualizarConsultorias() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .obterConsultoriasPorAcao(this.acao.idAcaoPlanoTrabalho)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.consultoriasLista = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter os consultorias da ação.',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    mounted() {
        if (this.consultorias) {
            this.consultoriasLista = this.consultorias
        }
    },

    watch: {
        consultorias() {
            this.consultoriasLista = this.consultorias
        }
    }
}
</script>
